<section class="w-full grid grid-cols-1 gap-2">
    <tui-carousel
        #carouselTop
        *tuiLet="photoIndex$ | async as photoIndex"
        [index]="photoIndex!"
        [draggable]="false"
        [itemsCount]="1"
        [style.--tui-carousel-padding]="0"
    >
        <ng-container *ngFor="let item of photos">
            <ng-container *ngrxLet="imageSize$ as imageSize">
                <div
                    *tuiItem
                    class="{{ imageSize.aspect }} overflow-hidden rounded-md bg-gray-200 hover:opacity-75 w-full"
                >
                    <img
                        class="h-full w-full object-cover object-center"
                        [ngSrc]="item"
                        [width]="imageSize.width"
                        [height]="imageSize.height"
                        alt=""
                        draggable="false"
                        loading="eager"
                    />
                </div>
            </ng-container>
        </ng-container>
    </tui-carousel>

    <div *ngIf="photos.length > 1" tuiCarouselButtons class="relative hidden lg:block" (touchstart.passive.stop)="(0)">
        <button
            tuiIconButton
            type="button"
            size="s"
            icon="svg::chevron-left"
            class="!absolute top-1/2 left-1 z-30 !bg-gray-200 -translate-y-1/2"
            (click)="navigate(-1)"
        ></button>
        <tui-carousel
            #carousel
            *tuiLet="photoIndex$ | async as photoIndex"
            [index]="photoIndex!"
            [draggable]="false"
            [itemsCount]="4"
            [style.--tui-carousel-padding]="0"
            class="carousel-bottom"
        >
            <ng-container *ngFor="let item of photos; let i = index">
                <div
                    *tuiItem
                    class="aspect-square overflow-hidden rounded-md bg-gray-200 border border-gray-100 p-1 w-24 h-24 opacity-50 hover:opacity-100"
                    [class.opacity-100]="i === photoIndex"
                    [class.border-purple-500]="i === photoIndex"
                    (click)="selectImage(i)"
                >
                    <img
                        class="h-full w-full object-cover object-center"
                        [ngSrc]="item"
                        [width]="112"
                        [height]="112"
                        alt=""
                        draggable="false"
                        loading="lazy"
                    />
                </div>
            </ng-container>
        </tui-carousel>
        <button
            tuiIconButton
            type="button"
            size="s"
            icon="svg::chevron-right"
            class="!absolute top-1/2 right-1 z-30 !bg-gray-200 -translate-y-1/2"
            (click)="navigate(1)"
        ></button>
    </div>
</section>
